import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

// Polls unseen demo leads for the Super Admin header; fires a browser notification when the count rises.
export const useUnseenLeads = (intervalMs = 60000) => {
  const [data, setData] = useState({ unseen: 0, latest: null });
  const prev = useRef(null);
  useEffect(() => {
    let alive = true;
    const tick = async () => {
      try {
        const { data: d } = await axios.get('/superadmin/leads/unseen');
        if (!alive) return;
        if (prev.current !== null && d.unseen > prev.current && typeof Notification !== 'undefined' && Notification.permission === 'granted') {
          new Notification('New DecoWorkflow demo lead', { body: d.latest ? `${d.latest.company_name} — ${d.latest.full_name}` : `${d.unseen} unseen lead(s)` });
        }
        prev.current = d.unseen;
        setData(d);
      } catch { /* ignore polling errors */ }
    };
    tick();
    const id = setInterval(tick, intervalMs);
    return () => { alive = false; clearInterval(id); };
  }, [intervalMs]);
  const markSeen = async () => { try { await axios.post('/superadmin/leads/mark-seen', {}); setData({ unseen: 0, latest: null }); prev.current = 0; } catch { /* ignore */ } };
  return { ...data, markSeen };
};

export const UnseenBadge = ({ count, testId }) => (count > 0 ? (
  <span data-testid={testId} style={{ background: '#D90000', color: '#fff', borderRadius: 10, fontSize: 10, fontWeight: 800, padding: '1px 6px', lineHeight: '14px' }}>{count}</span>
) : null);
